import { Vehicle } from "src/app/models/vehicle";
import { GraphqlVehicleOutput } from "../models/output/vehicle-output.model";

export function convertGraphqlVehicleOutputToVehicle(input: GraphqlVehicleOutput): Vehicle {
	return {
    name: input.Name,
    vinNo: input.VinNumber,
    vehicleOwnerName: input.VehicleOwnerName,
    typeDesignation: input.TypeDesignation
};
}
